import { SettingsParser } from "./settings-parser";
import { CanvasParser } from "./canvas-parser";
import { CanvasSettings } from "../settings/canvas-settings";
import { ObjectCreator } from "../../../../../web-graphics";

export class FpsCanvasParser extends CanvasParser {
  constructor(viewObjectParsers) {
    super(viewObjectParsers);
    this.parsedFieldNames.push("withFpsMeter");
  }

  static createSettings(settings, defaultSettings, viewObjectParsers) {
    let parsedSettings = CanvasParser.createSettings(settings, defaultSettings, viewObjectParsers);
    if (parsedSettings === undefined) {
      return undefined;
    }
    parsedSettings.withFpsMeter = settings.withFpsMeter ?? defaultSettings?.withFpsMeter ?? false;
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = FpsCanvasParser.createSettings(settings, defaultSettings, this.viewObjectParsers);
    if (parsedSettings === undefined) {
      return undefined;
    }
    SettingsParser.parseRestFields(settings, defaultSettings, this.parsedFieldNames, parsedSettings);
    return new CanvasSettings(parsedSettings, ObjectCreator.shallowCopy);
  }
}
